import { createContext, useMemo } from "react";
import { createTheme } from "@mui/material/styles"



export const tokens = () => ({
    primary: {
        100: "#494949",
        200: "#ffffffff"
    },
    green: {
        100: "#cce3e6ff",
        200: "#40b4ba",
        300: "#4caf50"
    },
    orange : {
        100: "#FFE3E1", 
        200: "#FFBFBA",
        300: "#FF9992",
        400: "#fd756b",
        500: "#E0473D"
    },
    yellow: {
        100: "#e8d56c",
    },
    blue: {
        100: "#567eb9",
    },
    purple: {
        100: "#9c7eb6",
    },
    grey: {
        100: "#EEEEEE", 
        200: "#E0E0E0", 
        300: "#D9D9D9", 
        400: "#ffffffB3",
        500: "#999999",
        600: "#666666",  
        700: "#00000014", 
    }
});




const themeSettings = () => {
    const colors = tokens();

    return {
        palette: {
            primary: {
                main: colors.primary[100],
            },
            secondary: {
                main: colors.green[200],
            },
            background: {
                default: "#ffffffff",
            }
        },
        typography: {
            fontFamily: ["Avenir", "Avenir Regular", "sans-serif"].join(","),
            fontSize: 12,

            fontWeightLight: 300,
            fontWeightRegular: 400,
            fontWeightMedium: 600,
            fontWeightBold: 700,

            body1: { fontSize: 13, lineHeight: 1.25, fontWeight: 400 },
            body2: { fontSize: 12, lineHeight: 1.25, fontWeight: 400 },
            caption: { fontSize: 11, lineHeight: 1.2, fontWeight: 400 },
            subtitle1: { fontSize: 13, lineHeight: 1.25, fontWeight: 600 },
            subtitle2: { fontSize: 12, lineHeight: 1.2, fontWeight: 600 },

            h1: { fontSize: 40, fontWeight: 700 },
            h2: { fontSize: 32, fontWeight: 700 },
            h3: { fontSize: 24, fontWeight: 700 },
            h4: { fontSize: 20, fontWeight: 700 },
            h5: { fontSize: 16, fontWeight: 700 },
            h6: { fontSize: 14, fontWeight: 700 },
        },

        tooltip: {
            color: "#626262"
        }
    };
};


// context for color mode

export const ColorModeContext = createContext({
    toggleColorMode: () => { }
})


export const useMode = () => {

    const theme = useMemo(
        () => createTheme(themeSettings()),
        []
    );

    return [theme];
};


